import(/* webpackMode: "eager" */ "/opt/build/repo/app/contact/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/opt/build/repo/node_modules/.pnpm/@apollo+client-react-streaming@0.12.3_@apollo+client@3.14.0_@types+react@19.2.7_graphql_c0c766c31ff4aebbf1d458a7a578c58f/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["Role"] */ "/opt/build/repo/node_modules/.pnpm/@ariakit+react@0.4.17_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/@ariakit/react/esm/index.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/facebook.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/instagram.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/linkedin.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/location-pin.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/phone.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/threads.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/youtube.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/logos/legal-logo.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/grid/column/column.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/grid/context.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/link/link.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/markdown/markdown.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/textBlock/textBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/quickLinks/quickLinks.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/header/header.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/newsletter/newsletter.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/styles/spacing.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Email"] */ "/opt/build/repo/src/v1/components/email/email.tsx");
